import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "icon-row" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "main-container" }
const _hoisted_9 = { class: "preview" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "description" }
const _hoisted_13 = { style: {"margin-bottom":"0","margin-top":"0","display":"inline-block"} }
const _hoisted_14 = { style: {"color":"gray"} }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "game-description" }
const _hoisted_24 = { class: "task-overview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_MSFS = _resolveComponent("MSFS")!
  const _component_CoopScoop = _resolveComponent("CoopScoop")!
  const _component_GudenuffEngine = _resolveComponent("GudenuffEngine")!
  const _component_InSheepsClothing = _resolveComponent("InSheepsClothing")!
  const _component_GallusEngine = _resolveComponent("GallusEngine")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock("video", {
      key: _ctx.selectedProject,
      class: "background-video",
      autoplay: "",
      muted: "",
      loop: "",
      "aria-hidden": "true"
    }, [
      _createElementVNode("source", {
        src: _ctx.getBackgroundVideo + '_c.mp4',
        type: "video/mp4"
      }, null, 8, _hoisted_1),
      _createElementVNode("source", {
        src: _ctx.getBackgroundVideo + '.webm',
        type: "video/webm"
      }, null, 8, _hoisted_2),
      _cache[0] || (_cache[0] = _createTextVNode(" Your browser does not support the video tag. "))
    ])),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reorderedProjects, (project, index) => {
        return (_openBlock(), _createElementBlock("picture", {
          key: index,
          title: project.name.toUpperCase(),
          class: _normalizeClass(["project-image", _ctx.selectedProject == index ? 'active' : '']),
          onClick: ($event: any) => (_ctx.setCurrentProject(index))
        }, [
          _createElementVNode("source", {
            srcset: _ctx.getLogo(project) + '.webp',
            type: "image/webp"
          }, null, 8, _hoisted_5),
          _createElementVNode("source", {
            srcset: _ctx.getLogo(project) + '.jpg',
            type: "image/jpg"
          }, null, 8, _hoisted_6),
          _createElementVNode("img", {
            src: `/src/projects/${project.link}/${project.link}_logo.jpg`,
            alt: ""
          }, null, 8, _hoisted_7)
        ], 10, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createElementBlock("video", {
          key: _ctx.selectedProject,
          class: "project-video",
          autoplay: "",
          muted: "",
          loop: "",
          "aria-hidden": "true"
        }, [
          _createElementVNode("source", {
            src: _ctx.getVideo + '.webm',
            type: "video/webm"
          }, null, 8, _hoisted_10),
          _createElementVNode("source", {
            src: _ctx.getVideo + '_c.mp4',
            type: "video/mp4"
          }, null, 8, _hoisted_11),
          _cache[1] || (_cache[1] = _createTextVNode(" Your browser does not support the video tag. "))
        ]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.currentProject.name.toUpperCase()) + " ", 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(" (" + _ctx.currentProject.year + ")"), 1)
        ]),
        _createElementVNode("p", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentProject.platforms, (platform, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, [
              (platform == _ctx.PROJECT_PLATFORM.STEAM)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "steamLink",
                    href: _ctx.currentProject.steamLink
                  }, [
                    _createVNode(_component_Icon, {
                      icon: _ctx.getPlatformIcon(platform)
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(" " + platform) + " ", 1),
                    (index !== _ctx.currentProject.platforms.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " | "))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_15))
                : (platform == _ctx.PROJECT_PLATFORM.GITHUB)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "steamLink",
                      href: _ctx.currentProject.gitHubLink
                    }, [
                      _createVNode(_component_Icon, {
                        icon: _ctx.getPlatformIcon(platform)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(" " + platform) + " ", 1),
                      (index !== _ctx.currentProject.platforms.length - 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, " | "))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_17))
                  : (platform == _ctx.PROJECT_PLATFORM.ITCH)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "steamLink",
                        href: _ctx.currentProject.itchLink
                      }, [
                        _createVNode(_component_Icon, {
                          icon: _ctx.getPlatformIcon(platform)
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(" " + platform) + " ", 1),
                        (index !== _ctx.currentProject.platforms.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, " | "))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_19))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                        _createVNode(_component_Icon, {
                          icon: _ctx.getPlatformIcon(platform)
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(" " + platform) + " ", 1),
                        (index !== _ctx.currentProject.platforms.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " | "))
                          : _createCommentVNode("", true)
                      ]))
            ]))
          }), 128))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_Icon, {
            icon: _ctx.getEngineIcon(_ctx.currentProject.engine)
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(" " + _ctx.currentProject.engine) + " in " + _toDisplayString(_ctx.currentProject.language), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentProject.me?.roles, (role, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: "role",
            style: _normalizeStyle('background: ' + _ctx.currentProject.accentColor)
          }, _toDisplayString(role.toUpperCase()), 5))
        }), 128)),
        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.currentProject.description), 1),
        _createElementVNode("div", _hoisted_24, [
          _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Task Overview", -1)),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentProject.tasks, (task, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "game-description game-list",
                key: index
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(task)))
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    (_ctx.currentProject.link == 'msfs')
      ? (_openBlock(), _createBlock(_component_MSFS, {
          key: 0,
          projectData: _ctx.currentProject
        }, null, 8, ["projectData"]))
      : _createCommentVNode("", true),
    (_ctx.currentProject.link == 'coopscoop')
      ? (_openBlock(), _createBlock(_component_CoopScoop, {
          key: 1,
          projectData: _ctx.currentProject
        }, null, 8, ["projectData"]))
      : _createCommentVNode("", true),
    (_ctx.currentProject.link == 'gudenuffengine')
      ? (_openBlock(), _createBlock(_component_GudenuffEngine, {
          key: 2,
          projectData: _ctx.currentProject
        }, null, 8, ["projectData"]))
      : _createCommentVNode("", true),
    (_ctx.currentProject.link == 'insheepsclothing')
      ? (_openBlock(), _createBlock(_component_InSheepsClothing, {
          key: 3,
          projectData: _ctx.currentProject
        }, null, 8, ["projectData"]))
      : _createCommentVNode("", true),
    (_ctx.currentProject.link == 'gallusengine')
      ? (_openBlock(), _createBlock(_component_GallusEngine, {
          key: 4,
          projectData: _ctx.currentProject
        }, null, 8, ["projectData"]))
      : _createCommentVNode("", true)
  ]))
}